export default __webpack_public_path__ + "static/media/fold.c5f5a3a3.mp3";